import paths from "../../Infrastructure/Router/paths";

// SEO titles/descriptions used ONLY when the `organizations` flag is on.
// Keyed by route path; anything not listed falls back to the existing config.
const organizationSeo = {
  [paths.home.path]: {
    title: "Vulcan Learning",
    description:
      "The all-in-one platform for academies, bootcamps, and training organizations to offer live online classes: course pages, onboarding, scheduling, payments, video, and more.",
  },
  [paths.ourMission.path]: {
    title: "Our Mission | Vulcan Learning",
    description:
      "Helping education organizations deliver world-class live learning online.",
  },
  [paths.contactPage.path]: {
    title: "Contact | Vulcan Learning",
    description: "Book a demo or get in touch with the Vulcan Learning team.",
  },
};

export default organizationSeo;
